import { render, staticRenderFns } from "./BProfilePreview.vue?vue&type=template&id=55dbc8d5&scoped=true&"
import script from "./BProfilePreview.vue?vue&type=script&lang=js&"
export * from "./BProfilePreview.vue?vue&type=script&lang=js&"
import style0 from "./BProfilePreview.vue?vue&type=style&index=0&id=55dbc8d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dbc8d5",
  null
  
)

export default component.exports